import { render, staticRenderFns } from "./ModalItemNotesV2.vue?vue&type=template&id=adb6d9fa&scoped=true"
import script from "./ModalItemNotesV2.vue?vue&type=script&lang=js"
export * from "./ModalItemNotesV2.vue?vue&type=script&lang=js"
import style0 from "./ModalItemNotesV2.vue?vue&type=style&index=0&id=adb6d9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb6d9fa",
  null
  
)

export default component.exports